module.exports = [
	{
		"id": "125608",
		"image": "//cdn.cloud.grohe.com/prod/10/12/125608/640/125608.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Faucet and M size boiler",
		"textblock_1st_text": "125608",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/125608",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091001/640/30091001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30091001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/30091001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30091DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30091DC1/640/30091DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur und Boiler Größe L",
		"textblock_1st_text": "30091DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/30091DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mixing valve",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mitigeur bec U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en U, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, finition chromée.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - mitigeur bec L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Duo : mitigeur d\\'évier monocommande pour une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en L, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Kit de démarrage - Mono",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Kit de démarrage GROHE Blue Home Mono : robinet sur colonnette fournissant une eau filtrée, réfrigérée et gazeuse. Inclut une unité réfrigérante, un filtre et une bouteille de CO2 pour la gazéification. Bec haut en C, aspect acier inoxydable.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/fr_ch/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/fr_ch/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_fr_ch.json
// module id = 871
// module chunks = 0